declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, DoctorsListController, DoctorsListRequest, StoreLocationMaterialsRequest, StoreLocationMaterialsController, TradedDrugDetailViewController, TradedDrugDetailViewRequest, SaveClinicalOrderRxHeaderInfoRequest, ClinicalOrderRxItemsController, ClinicalOrderRxItemsRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe, Drugslistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbAddPrescriptionMedicineModal, MedicineDetails } from './modal/addprescriptionmedicine.modal';
import { NgbEditPrescriptionMedicineModal } from './modal/editprescriptionmedicine.modal';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../_MasterClasses/BillingClasses';




@Component({
  selector: ' prescriptionreceipt',
  templateUrl: './prescriptionreceipt.component.html',
  styleUrls: ['./prescriptionreceipt.component.scss']
  , animations: [routerTransition()]
})

export class PrescriptionreceiptComponent implements OnInit {


  public ApiResData: ApiResponseModel;
  @Input() FormattedCode: string;

  public ActorCode: number = 0;
  //public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowList: boolean = true;
  public ShowPatientDetails: boolean = false;
  public receipt: boolean = true;
  public opbilling: boolean = false;
  public Add: boolean = true;
  public Edit: boolean = false;
  public LChargeEntryCode: number = 0;
  public Tdiscount: number;
  public selectedGroup: any;
  // public Tdiscount: number = 0;
  public isRequesting: boolean = false;
  public PrescriberData: PrescribingDoctor[];
  public ReferalData: ReferringDoctor[];
  public cash: boolean = false;
  public card: boolean = false;
  public cheque: boolean = false;
  public demanddraft: boolean = false;
  public paytm: boolean = false;
  public FormattedCodedata: any;
  public Prescribername: any;
  public Prescribercode: number = 0;
  public Prescriberdesg: any;
  public Referalname: any;
  public ReferalCode: any;
  public Referaldesg: any;
  public TotalBill: number;
  public Orderentrycode: number = 0;
  public NetPayable: number;
  public BranchName: string; 
  public Date: Date;
  public ChargeEntryCodeModal: number = 0;
  public FaclityCodeData: any;
  searchTitle: string;
  // public SelectedPrescriber: PrescribingDoctor[];
  //public SelectedReferral: ReferringDoctor[];
  CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
  CurrentSaveClinicalOrderRxHeaderInfoRequest: SaveClinicalOrderRxHeaderInfoRequest;
    CurrentEditClinicalOrderRxHeaderInfoRequest: SaveClinicalOrderRxHeaderInfoRequest;
    CurrentDeleteClinicalOrderRxHeaderInfoRequest: SaveClinicalOrderRxHeaderInfoRequest;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients(FormattedCode: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadSign();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Drugslistpipe, private spinner: NgxSpinnerService


  ) { }

  ngOnInit() {

    this.Tdiscount = 0;
    this.FormattedCodedata = this.route.snapshot.paramMap.get('FormattedCode');
    this.FaclityCodeData = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest = new SaveClinicalOrderRxHeaderInfoRequest();
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest = new SaveClinicalOrderRxHeaderInfoRequest();
      this.CurrentEditClinicalOrderRxHeaderInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentDeleteClinicalOrderRxHeaderInfoRequest = new SaveClinicalOrderRxHeaderInfoRequest();
      this.CurrentDeleteClinicalOrderRxHeaderInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.route.queryParams
    //    .subscribe(params => {
    //        this.Prescribername = params.PrescriberName;
    //        this.FormattedCodedata = params.FormattedCodedata;
    //        this.Prescribercode = params.PrescriberCode;
    //        this.Prescriberdesg = params.Prescriberdesignation;
    //        this.Referalname = params.RefName;
    //        this.ReferalCode = params.RefCode;
    //        this.Referaldesg = params.Refdesignation;

    //    }
    //    );
    //alert(this.Prescribercode);
    this.LoadPatients(this.FormattedCodedata);
    //this.Prescribercode = 0;
    // this.LoadServicesByCategory(this.Prescribercode);
    //this.StoreItems();
    this.StoreItems2();
    this.LoadDoctorsList();
    //this.LoadDoctorPres();
    this.LoadDoctorRef();
    this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
    this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  }

  CurrentStoreLocationMaterialsRequest: StoreLocationMaterialsRequest;
  CurrentStoreLocationMaterialsController: StoreLocationMaterialsController[];
  StoreItems() {
    // alert()
    this.CurrentStoreLocationMaterialsRequest = new StoreLocationMaterialsRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;

    this.CurrentStoreLocationMaterialsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentStoreLocationMaterialsRequest.ConditionalOperator = 10;
    this.CurrentStoreLocationMaterialsRequest.StoreCode = 3;
    this.pdata = this.CurrentStoreLocationMaterialsController;

    this.GetStoreLocationMaterialsController();

  }
  GetStoreLocationMaterialsController() {
    this.StartRefreshing();
    this.spinner.show();
    this.actorservice.GetStoreLocationMaterialsController(this.CurrentStoreLocationMaterialsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentStoreLocationMaterialsController = this.ApiResData.Result;
          this.pdata = this.CurrentStoreLocationMaterialsController;
          this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  CurrentTradedDrugDetailViewRequest: TradedDrugDetailViewRequest;
  CurrentTradedDrugDetailViewController: TradedDrugDetailViewController[];
  StoreItems2() {
    // alert()
    this.CurrentTradedDrugDetailViewRequest = new TradedDrugDetailViewRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;

    this.CurrentTradedDrugDetailViewRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentTradedDrugDetailViewRequest.ConditionalOperator = 10;
    this.CurrentTradedDrugDetailViewRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.pdata = this.CurrentTradedDrugDetailViewController;

    this.GetTradedDrugDetailViewController();

  }
  GetTradedDrugDetailViewController() {
    this.StartRefreshing();
    this.spinner.show();
    this.actorservice.GetTradedDrugDetailViewController(this.CurrentTradedDrugDetailViewRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {
          this.CurrentTradedDrugDetailViewController = this.ApiResData.Result;
          this.pdata = this.CurrentTradedDrugDetailViewController;
          this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  CurrentClinicalOrderRxItemsController: ClinicalOrderRxItemsController[];

  CurrentClinicalOrderRxItemsRequest: ClinicalOrderRxItemsRequest;


  LoadPreDetails() {
    // alert("one");
    this.CurrentClinicalOrderRxItemsRequest = new ClinicalOrderRxItemsRequest();

    this.CurrentClinicalOrderRxItemsRequest.ConditionalOperator = 10;
    this.CurrentClinicalOrderRxItemsRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentClinicalOrderRxItemsRequest.OrderCode = this.Orderentrycode;
    this.CurrentClinicalOrderRxItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetClinicalOrderRxItemsController();

  }

  GetClinicalOrderRxItemsController() {


    // alert('loading forms: ' + this.ActorCode);
    this.StartRefreshing();
    this.spinner.show();
    //this.CurrentPatientwiseLabReportsRequest.PatientFormattedCode = this.FormattedCode;
    //alert('loading forms: ' + this.FormattedCode);
    //this.LoadMedicalHistory_new();


    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetClinicalOrderRxItemsController(this.CurrentClinicalOrderRxItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentClinicalOrderRxItemsController = this.ApiResData.Result;
          //this.OrderDate = this.SelectedTestDetails.OrderDate;
          //this.GetTestData(this.SelectedTestDetails.OrderRequestCode);
          // this.OrderCode = this.SelectedTestDetails.OrderRequestCode;
          //this.GetTestData();
          //this.GetTestData(this.SelectedTestDetails.OrderRequestCode);

          //this.TestData = this.ApiResData.Result
          //var Testlist = this.TestData.filter(
          //    function (a) {

          //        return a.OrderDate == this.OrderDate

          //    });
          //this.TestData = Testlist;
          //alert(this.TestData.length);
          this.spinner.hide();
          this.stopRefreshing();
        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
            this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
            this.spinner.hide();
          }
        }


      );
  }
  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;

  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    // this.pdata = this.CurrentDoctorsListController;
    //this.pdata1 = this.CurrentDoctorsListController;
    this.CurrentDoctorsListRequest.ConditionalOperator = 20;
    this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorsListController = this.ApiResData.Result;
          //this.pdata = this.CurrentDoctorsListController;
          //this.pdata1 = this.CurrentDoctorsListController;
          //alert(this.CurrentServiceCategoriesController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  selectedGroupnew: PrescribingDoctor;
  onChange(Event: any) {
    //alert(Event.value);
    if (Event != null) {
      var a = this.CurrentDoctorsListController.filter(X => X.ProviderCode == Event.value)
      //alert(a.length);
      if (a.length > 0) {

        this.Prescribername = a[0].DisplayName;
        this.Prescribercode = a[0].ProviderCode;
        this.Prescriberdesg = a[0].Specialty;
        this.LoadDoctorPres();
        //this.LoadServicesByCategory(this.Prescribercode);
        //alert(this.Prescribername);

        //        // alert(this.ActivityDate);
      }
    }
  }
  CurrentPrescribingDoctor: Array<PrescribingDoctor>;
  LoadDoctorPres() {
    // alert(Selectedgroupnew.DoctorName + "," + Selectedgroupnew.DoctorCode);
    if (this.CurrentPrescribingDoctor == null) {
      this.CurrentPrescribingDoctor = new Array<PrescribingDoctor>();
    }
    if (this.CurrentPrescribingDoctor != null) {
      var row = new PrescribingDoctor();
      row.DoctorName = this.Prescribername;
      row.DoctorCode = this.Prescribercode;
      row.Designation = this.Prescriberdesg;
      //row.DoctorName = Selectedgroupnew.DoctorName;
      // row.DoctorCode = Selectedgroupnew.DoctorCode;
      // row.Designation = Selectedgroupnew.Designation;
      this.CurrentPrescribingDoctor.push(row);
    }
  }

  CurrentReferringDoctor: Array<ReferringDoctor>;

  LoadDoctorRef() {
    if (this.CurrentReferringDoctor == null) {
      this.CurrentReferringDoctor = new Array<ReferringDoctor>();
    }
    if (this.CurrentReferringDoctor != null) {
      var row = new ReferringDoctor();
      row.DoctorName = "";
      row.DoctorCode = 0;
      row.Designation = "";
      this.CurrentReferringDoctor.push(row);
    }
  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }
  cashdata() {
    this.cash = true;
  }
  carddata() {
    this.card = true;
  }
  chequedata() {
    this.cheque = true;
  }
  demanddraftdata() {
    this.demanddraft = true;
  }
  paytmdata() {
    this.paytm = true;
  }
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentTradedDrugDetailViewController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentTradedDrugDetailViewController,
          this.listFilter);
      }
    }
  }

  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  //docedit() {

  //    const modalRef = this.modalService.open(NgbAddBill,
  //        {
  //            centered: true,
  //            size: "lg",
  //            backdrop: 'static',
  //            keyboard: false
  //        })
  //    modalRef.componentInstance.FormattedCode = this.FormattedCodedata;
  //    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
  //        this.SelectedPrescriber = receivedEntry.make;
  //        this.SelectedReferral = receivedEntry.value;

  //       alert(this.ProvidedName);
  //    })


  //}
  CancelNewOperation() {

    this.ShowList = true;
  }
  back() {
    this.receipt = false;
    this.opbilling = true;
    this.router.navigate(['/healins/opbilling']);
    //this.router.navigate.['/healins/opbilling'];
  }
  payment() {
    const modalRef = this.modalService.open(NgbPayBillModal,
      {
        centered: true,
        size: "lg"
      })
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  CurrentMedicineDetails: Array<MedicineDetails>;
  AddRow(l: MedicineDetails) {
    //  alert(l.MedicineName);
    if (this.CurrentMedicineDetails == null) {
      this.CurrentMedicineDetails = new Array<MedicineDetails>();
    }
    if (this.CurrentMedicineDetails != null) {
      var row = new MedicineDetails();
      row.Dose = l.Dose;
      row.DurationType = l.DurationType;
      row.Frequency = l.Frequency;
      row.Instructions = l.Instructions;
      row.MedicineName = l.MedicineName;
      row.MedicineCode = 0;
      row.Purpose = l.Purpose;
      row.Route = l.Route;
      row.StartDate = l.StartDate;
      row.ToDate = l.ToDate;
      this.CurrentMedicineDetails.push(row);
    }
    this.Date = new Date();
    //        alert(l.BasePrice);

    //this.AddData();

  }
  CurrentNewBillData: NewBillData;
  AddData() {
    this.CurrentNewBillData = new NewBillData();
    this.CurrentNewBillData.ActorCode = this.SelectedPatientFormattedCode.ActorCode;


    this.CurrentNewBillData.BillDate = new Date();
    this.CurrentNewBillData.BillSource = "Internal";
    this.CurrentNewBillData.BillStatus = "";
    this.CurrentNewBillData.BillType = "OP";
    this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentNewBillData.BranchName = AppData.Instance().SelectedBranchName;
    this.CurrentNewBillData.ChargeEntryCode = this.LChargeEntryCode;
    this.CurrentNewBillData.Gender = this.SelectedPatientFormattedCode.Gender;
    // this.CurrentNewBillData.Items = this.CurrentBillDetails;
    this.CurrentNewBillData.PrescriberDoctor = this.CurrentPrescribingDoctor;
    this.CurrentNewBillData.ReferringDoctor = this.CurrentReferringDoctor;
    this.CurrentNewBillData.PatientFormattedCode = this.SelectedPatientFormattedCode.FormattedCode;
    this.CurrentNewBillData.PatientName = this.SelectedPatientFormattedCode.DisplayName;
    this.CurrentNewBillData.PhoneNumber = this.SelectedPatientFormattedCode.Telephone1;
    this.CurrentNewBillData.TotalDiscount = this.Tdiscount;
    //this.CurrentNewBillData.TotalBill = this.CurrentBillDetails.filter((item) => item.ItemRate)
    // .map((item) => +item.ItemRate)
    // .reduce((sum, current) => sum + current);
    //this.CurrentNewBillData.NetPayable = this.CurrentBillDetails.filter((item) => item.ItemRate)
    //.map((item) => +item.ItemRate)
    //.reduce((sum, current) => sum + current) - this.Tdiscount;
    //this.CurrentNewBillData
    this.SaveData();


  }
  AddRow2(l: TradedDrugDetailViewController) {
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.GenericMedicineCode = l.GenericCode;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.GenericMedicineName = l.GenericName;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.MedicineTradeCode = l.TradeNameCode;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.MedicineTradeName = l.TradeName;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.RecordStatus = "";
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.ClinicalOrderEntry = this.Orderentrycode;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.ClinicalOrderRxItemCode = 0;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.OrderType = "";
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.OrderEntryType = "";
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.OrderringProvider = this.Prescribercode;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.Form = "";
    //this.CurrentSaveClinicalOrderRxHeaderInfoRequest.OrderTypeReference = 0;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.TradedDrugDetailCode = l.TradedDrugDetailCode;
    //this.CurrentSaveClinicalOrderRxHeaderInfoRequest.VisitCode = 0;
    this.CurrentSaveClinicalOrderRxHeaderInfoRequest.PatientCode = this.SelectedPatientFormattedCode.PatientRegistrationNumber;
    const modalRef = this.modalService.open(NgbAddPrescriptionMedicineModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.MedicineName = l.TradeName;
    modalRef.componentInstance.CurrentSaveClinicalOrderRxHeaderInfoRequest = this.CurrentSaveClinicalOrderRxHeaderInfoRequest;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.Orderentrycode = receivedEntry.Orderentrycode;

      this.LoadPreDetails();
      //if (this.CurrentMedicineDetails == null) {
      //    this.CurrentMedicineDetails = new Array<MedicineDetails>();
      //}
      //if (this.CurrentMedicineDetails != null) {
      //    var row = new MedicineDetails();
      //    row.Dose = receivedEntry.make[0].Dose;
      //    row.DurationType = receivedEntry.make[0].DurationType;
      //    row.Frequency = receivedEntry.make[0].Frequency;
      //    row.Instructions = receivedEntry.make[0] .Instructions;
      //    row.MedicineName = receivedEntry.make[0].MedicineName;
      //    row.MedicineCode = 0;
      //    row.Purpose = receivedEntry.make[0].Purpose;
      //    row.Route = receivedEntry.make[0].Route;
      //    row.StartDate = receivedEntry.make[0].StartDate;
      //    row.ToDate = receivedEntry.make[0].ToDate;
      //    this.CurrentMedicineDetails.push(row);
      //    alert(this.CurrentMedicineDetails[0].DurationType);
      //}





    })

  }
  SaveData() {
    this.spinner.show();
    this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
    this.CurrentSaveBillItemsInfoRequest.ChargeEntry = this.LChargeEntryCode.toString();
    this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 10;
    this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
      .subscribe((result) => {

        this.ApiResData = result;
        if (result.Result[0].Result > 0) {
          //if (!this.ApiResData.hasError) {

          //   if (this.ApiResData.Result > 0) {
          this.LChargeEntryCode = this.ApiResData.Result[0].Result;
          // alert(this.LChargeEntryCode);
          //this.GetActorEducationInfoController();
          //this.GetResourceIdentificationByDateInfoController();
          // alertFunctions.AlertParam('Saved Successfully.....!');
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          // this.Listview = true;
          //this.EditEmbryo = false;
          //this.LoadStoreData();
          //this.AddEmbryo = false;
          //this.spinner.hide();
          //this.activeModal.close();
          //this.clearData();
          // this.LoadScansData();
          this.stopRefreshing();
          this.spinner.hide();
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");

          //this.spinner.hide();
          this.stopRefreshing();
          this.spinner.hide();
        }

      },





        (error) => {
          // alert("kkhkhjkhkjhjkh");

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }
  Qunatitychange(l: BillDetails) {


    l.ItemRate = l.Quantity * l.UnitPrice;
    //this.TotalBill = this.CurrentBillDetails.filter((l) => l.ItemRate)
    // .map((l) => +l.ItemRate)
    ///.reduce((sum, current) => sum + current);
    // l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);

    //this.Tdiscount = this.CurrentBillDetails.filter((l) => l.rDiscount)
    //  .map((l) => +l.rDiscount)
    // .reduce((sum, current) => sum + current);
    this.NetPayable = this.TotalBill - this.Tdiscount;

  }
  Discountchange(l: BillDetails) {


    l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);

    //this.Tdiscount = this.CurrentBillDetails.filter((l) => l.rDiscount)
    // .map((l) => +l.rDiscount)
    //.reduce((sum, current) => sum + current);
    this.NetPayable = this.TotalBill - this.Tdiscount;
  }

  //alert(this.CurrentBillDetails.length);
  // CurrentBillDetailsEdit: BillDetails;

    delete(l: ClinicalOrderRxItemsController) {
       // this.spinner.show();
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.deleterow(l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })

  }
    deleterow(l: ClinicalOrderRxItemsController) {
        //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
        this.spinner.show();
        this.CurrentDeleteClinicalOrderRxHeaderInfoRequest.ConditionalOperator = 40;
        this.CurrentDeleteClinicalOrderRxHeaderInfoRequest.ClinicalOrderEntry = l.ClinicalOrderEntryCode;
        this.CurrentDeleteClinicalOrderRxHeaderInfoRequest.ClinicalOrderRxItemCode = l.ClinicalOrderRxItemCode;

        this.actorservice.SaveClinicalOrderRxHeaderInfo(this.CurrentDeleteClinicalOrderRxHeaderInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;

                if (result.Result[0].ClinicalOrderEntry > 0) {
                    this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                   
                    //if (!this.ApiResData.hasError) {

                    //   if (this.ApiResData.Result > 0) {
                   // this.Orderentrycode = this.ApiResData.Result[0].ClinicalOrderEntry;
                    //alert(this.Orderentrycode);
                  
                   
                    
                    // this.Listview = true;
                    //this.EditEmbryo = false;
                    //this.LoadStoreData();
                    //this.AddEmbryo = false;
                    //this.spinner.hide();
                    //this.activeModal.close();
                    //this.clearData();
                    // this.LoadScansData();
                    this.stopRefreshing();
                    this.spinner.hide();
                }
                else {
                    alertFunctions.AlertParam("Invalid Operation :- " + "...!");

                    //this.spinner.hide();
                    this.stopRefreshing();
                    this.spinner.hide();
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                       // this.activeModal.close();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                       // this.activeModal.close();
                        this.stopRefreshing();
                    }
                }
            );

  }
  OnClear(l: BillDetails) {
    l.Edit = false;
  }
  Payment() {
    const modalRef = this.modalService.open(NgbPaymentModal,
      {
        centered: true,
        size: "lg"

      })
    modalRef.componentInstance.FormattedCode = this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode;
    modalRef.componentInstance.PatientImage = this.CurrentPatientInfoByFormattedCodeController[0].PatientImageFile;
    modalRef.componentInstance.PatientName = this.CurrentPatientInfoByFormattedCodeController[0].DisplayName;
    modalRef.componentInstance.Age = this.CurrentPatientInfoByFormattedCodeController[0].Age;
    modalRef.componentInstance.Gender = this.CurrentPatientInfoByFormattedCodeController[0].Gender;
    modalRef.componentInstance.Telephone1 = this.CurrentPatientInfoByFormattedCodeController[0].Telephone1;
    modalRef.componentInstance.BillDate = this.CurrentNewBillData.BillDate;
    modalRef.componentInstance.TotalBill = this.CurrentNewBillData.TotalBill;
    modalRef.componentInstance.NetPayable = this.CurrentNewBillData.NetPayable;
    modalRef.componentInstance.Discount = this.CurrentNewBillData.TotalDiscount;
    modalRef.componentInstance.ActorCode = this.CurrentNewBillData.ActorCode;
    modalRef.componentInstance.ChargeEntryCode = this.LChargeEntryCode;
    modalRef.componentInstance.BillStatus = this.CurrentNewBillData.BillStatus;
    modalRef.componentInstance.BillType = this.CurrentNewBillData.BillType;
    modalRef.componentInstance.BillSource = this.CurrentNewBillData.BillSource;
    modalRef.componentInstance.BranchName = this.CurrentNewBillData.BranchName;
    modalRef.componentInstance.BranchCode = this.CurrentNewBillData.BranchCode;
    //modalRef.componentInstance.ItemsSelected = this.CurrentBillDetails;

    modalRef.componentInstance.Prescriber = this.CurrentPrescribingDoctor;
    modalRef.componentInstance.Refferal = this.CurrentReferringDoctor;

    modalRef.result.then((val: number) => {
      this.ChargeEntryCodeModal = val;
    });

  }
  Editrow(l: ClinicalOrderRxItemsController) {
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.GenericMedicineCode = l.GenericMedicineCode;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.GenericMedicineName = l.GenericMedicineName;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.MedicineTradeCode = l.MedicineTradeCode;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.MedicineTradeName = l.MedicineTradeName;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.DoseNumeric = 0;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.Duration = 0;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.RecordStatus = "";
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.ClinicalOrderEntry = l.ClinicalOrderEntryCode;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.ClinicalOrderRxItemCode = l.ClinicalOrderRxItemCode;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.OrderType = l.OrderType;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.OrderEntryType = l.OrderEntryType;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.OrderringProvider = l.OrderringProvider;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.Form = "";
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.OrderTypeReference = 0;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.TradedDrugDetailCode = l.MedicineTradeCode;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.PatientCode = this.SelectedPatientFormattedCode.PatientRegistrationNumber;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.Purpose = l.Purpose;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.Dose = l.Dose;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.DurationType = l.DurationType;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.Route = l.Route;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.Frequency = l.Frequency;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.Instructions = l.Instructions;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.IsStopped = l.IsStopped;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.StartDate = l.StartDate;
    this.CurrentEditClinicalOrderRxHeaderInfoRequest.EndDate = l.EndDate;
    const modalRef = this.modalService.open(NgbEditPrescriptionMedicineModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.MedicineName = l.MedicineTradeName;
    modalRef.componentInstance.ClinicalOrderRxItemCode = l.ClinicalOrderRxItemCode;
    modalRef.componentInstance.ClinicalOrderEntry = l.ClinicalOrderEntryCode;
    modalRef.componentInstance.CurrentEditClinicalOrderRxHeaderInfoRequest = this.CurrentEditClinicalOrderRxHeaderInfoRequest;
    modalRef.result.then(x => { this.GetClinicalOrderRxItemsController() });

  }

  Cancel() {
    this.router.navigate(['healins/opbilling']);
  }
  printprescription() {
    this.printService.printDocument("prescription",
      {
        OrderCodedata: this.Orderentrycode, FormattedCodedata: this.FormattedCodedata, FaclityCodeData: this.FaclityCodeData,
      }
    );
  }

}
//export class BillDetails {
//  public ItemCode: number;
//  public ServiceDescription: string;
//  public Quantity: number;
//  public UnitPrice: number;
//  public Discount: number;
//  public ItemRate: number;
//  public RowNumber: number;
//  public Edit: boolean;
//  public ServiceCode: number;
//  public ItemType: string;
//  public ItemGroup: string;
//  public GroupName: string;
//  public IsPackage: boolean;
//  public PackageName: string;
//  public ChargeItemCode: number;
//  public DiscountAllowed: boolean;
//  public rDiscount: number;
//  public CanModify: boolean;
//  public IsDeleted: boolean = false;  // editing purposes only... 

//}

//export class BillItemDeleted {

//  public ChargeItemCode: number;
//}

//export class PrescribingDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}
//export class ReferringDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}

